import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

const OrderResultMain = styled("div")(({ theme }) => ({
  background: "#FFFFFF",
  border: "1.17647px solid #D1D1D1",
  boxShadow: "0px 0px 4.70588px rgba(0, 0, 0, 0.05)",
  borderRadius: "16px",
  padding: "12px",
  marginBottom: "20px",
  overflow: "hidden",
  // margin: "0 10px",
  // [theme.breakpoints.down("sm")]: {
  //   width: "100%",
  // },

  // [theme.breakpoints.up("md")]: {
  //   width: "90%",
  // },

  // [theme.breakpoints.up("lg")]: {
  //   width: "90%",
  // },
}));

const OrderResultItem = styled("div")(({ theme }) => ({
  "&.locationsMain": {
    "& .OrderResult_text": {
      width: "80%",
      paddingRight: "15px",
    },
    "& .OrderResult_status": {
      width: "20%",
      textAlign: "right",
    },
    [theme.breakpoints.down("md")]: {
      "& .OrderResult_text": {
        width: "75%",
        paddingRight: "2px",
      },
      "& .OrderResult_status": {
        width: "25%",
        textAlign: "right",
      },
      "& .pickup_ItemMain::after": {
        height: "43%",
      },
    },
  },
  "&.orders_ids": {
    marginBottom: "5px",
    gap: "10px",
    justifyContent: "normal",
    alignItems: "center",
    "& span:first-child": {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "18px",
      letterSpacing: "0em",
      textAlign: "left",
      fontFamily: theme.typography.fontFamily,
      color: "#00000099",
    },
    "& span:nth-child(2)": {
      fontSize: "14px",
      fontWeight: 750,
      lineHeight: "18px",
      letterSpacing: "0em",
      textAlign: "left",
      fontFamily: theme.typography.fontFamily,
      color: "#000",
    },
    "& a": {
      fontSize: "14px",
      fontWeight: 750,
      lineHeight: "18px",
      letterSpacing: "0em",
      textAlign: "left",
      fontFamily: theme.typography.fontFamily,
      color: "#000",
      textDecoration: "none",
    },
  },
  display: "flex",
  justifyContent: "space-between",
  "& .OrderResult_status button": {
    textAlign: "center",
    padding: "0",
    minWidth: "auto",
    width: "auto",
    background: "transparent",
  },
  "& .pickup_ItemMain": {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "10px",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      left: "13px",
      top: "100%",
      height: "50%",
      width: "1px",
      borderLeft: "2px dashed rgba(11, 11, 11, 0.5)",
    },
    "& span": {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "16px",
      color: "#0B0B0B",
      fontFamily: theme.typography.fontFamily,
    },
  },
  "& .drop_ItemMain": {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "15px",
    "& span": {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "16px",
      color: "#0B0B0B",
      fontFamily: theme.typography.fontFamily,
    },
  },
  "& .OrderResult_status span": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "16px",
    fontFamily: theme.typography.fontFamily,
    textTransform: "capitalize",
  },
  "& .OrderResult_status span.onWay": { color: "#0075FF" },
  "& .OrderResult_status span.scheduled": { color: "#F69400" },
  "& .OrderResult_status span.completed": { color: "#11CF00" },
  "& .OrderResult_status span.inprogress": { color: "#0075FF" },
  "& .OrderResult_status span.approved": { color: "#0075FF" },
  "& .OrderResult_status span.driver_assigned": { color: "#0075FF" },
  "& .OrderResult_status span.cancelled": { color: "#F69400" },
  "& .OrderResult_status span.order_delivered": { color: "#11CF00" },
  "& .OrderResult_status span.driver_arrived": { color: "#FF9900" },
  "& .OrderResult_status span.driver_on_way_to_pickup": { color: "#0075FF" },
  "& .OrderResult_status span.driver_reached_at_drop_off": { color: "#9E00FF" },
  "& .OrderResult_status span.driver_departed": { color: "#C3006A" },
  "& .OrderResult_status span.pending": { color: "#D1D1D1" },
  "& .calendarMain": {
    paddingLeft: "5px",
  },

  "& .order_ids": {
    "& span": {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "16px",
      fontFamily: theme.typography.fontFamily,
    },
  },

  [theme.breakpoints.down("md")]: {
    "& .pickup_ItemMain": {
      gap: "5px",
      marginBottom: "15px",
      "& span": {
        fontSize: "14px",
      },
    },
    "& .drop_ItemMain": {
      gap: "5px",
      "& span": {
        fontSize: "14px",
      },
    },
  },
}));

const CancelButton = styled(Button)(({ theme }) => ({
  background: "#D1D1D1 !important",
  fontSize: "16px",
  lineHeight: "16px",
  color: "#0B0B0B",
  fontFamily: theme.typography.fontFamily,
  textTransform: "capitalize",
  padding: "6px 13px !important",
  borderRadius: "50px",
}));

const AddressSpan = styled("span")(({ theme }) => ({
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "16px",
  color: "#0B0B0B",
  fontFamily: theme.typography.fontFamily,
  overflowY: "hidden",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export { OrderResultMain, OrderResultItem, CancelButton, AddressSpan };
